<script setup lang="ts">
import Box from '@uiKit/elements/Box.vue'
import Text from '@uiKit/elements/Text.vue'
import AppImage from '@uiKit/elements/Image.vue'
import PiIcon from '@uiKit/elements/PiIcon.vue'

interface Props {
  image: string
  title: string
  location: string
}

defineProps<Props>()
</script>

<template>
  <Box align="center" gap="3" class="invest-strip">
    <Box class="invest-strip__img-wrap">
      <AppImage :src="image" :alt="title" image-class="invest-strip__img" />
    </Box>
    <Box direction="col" gap="1" grow class="invest-strip__text">
      <Text type="subheading" :truncate="true">{{ title }}</Text>
      <Box align="center" gap="1">
        <PiIcon name="map-marker" class="invest-strip__loc-icon" />
        <Text type="caption" color="muted" :truncate="true">{{ location }}</Text>
      </Box>
    </Box>
  </Box>
</template>

<style scoped>
.invest-strip {
  padding: 12px;
  border-radius: 12px;
  background: var(--p-surface-50);
  border: 1px solid var(--p-content-border-color);
}

.invest-strip__img-wrap {
  width: 72px;
  height: 56px;
  border-radius: var(--p-border-radius-md);
  overflow: hidden;
  background: var(--p-surface-100);
  flex-shrink: 0;
}

.invest-strip__img-wrap :deep(.invest-strip__img) {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.invest-strip__text {
  min-width: 0;
}

.invest-strip__loc-icon {
  font-size: 11px;
  color: var(--p-primary-500);
}
</style>
